
import axios from "axios";
import { store } from "store";
import { OutputBaseProps, PaginationProps } from "utils/types/API";
import { MessageItemProps } from ".";
import { loading, index, options } from "store/message";

interface ApiMessageInputProps {
    page?: number;
    pageSize?: number;
    q?: string;
}

type ApiMessageOutputProps = OutputBaseProps<{ list: MessageItemProps[]; pagination?: PaginationProps; }>;

export const apiMessageIndex = async (data: ApiMessageInputProps) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiMessageOutputProps>("/api/messages", { params: data }))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(index({ data: res.data.list, pagination: res.data.pagination }));
    }
    return res;
};

export const apiMessageOptions = async (data: { q?: string; }) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiMessageOutputProps>("/api/messages", { params: { ...data, fields: "id,code,name" } }))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(options({ data: res.data.list }));
    }
    return res;
};